var last = {};
export {
  last as __exports
};
//# sourceMappingURL=last2.js.map
